// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1PRCH","log":"ModalInventoryLogs_log__197_t","date":"ModalInventoryLogs_date__3tf3z","userName":"ModalInventoryLogs_userName__2vU_j"};